function handleError(err) {
  if (String(err).includes("user rejected transaction")) {
    return {
      title: "Error",
      message: "You rejected the transaction.",
    };
  } else {
    return {
      title: "Error",
      message: "An error occured.",
    };
  }
}

export default handleError;
